// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3CrHb","name":"Header_name__3tHDy","birthday":"Header_birthday__2tPl_","skeleton":"Header_skeleton__1miQH"};